"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uspList = void 0;
exports.uspList = [
    { featureId: '9281', featureName: 'Coastal' },
    { featureId: '10381', featureName: 'Hot Tub' },
    { featureId: '10380', featureName: 'Hot Tub' },
    { featureId: '9153', featureName: 'Luxury' },
    { featureId: '6948', featureName: 'Wifi' },
    { featureId: '9161', featureName: 'Swimming pool' },
    { featureId: '10408', featureName: 'Car parking on site' },
    { featureId: '6392', featureName: 'Enclosed Garden / Patio' },
    { featureId: '6455', featureName: 'Pub within 1 mile' },
    { featureId: '6946', featureName: 'Internet Connection' },
    { featureId: '10089', featureName: 'Coast within 1 mile' },
    { featureId: '6248', featureName: 'Detached' },
    { featureId: '6401', featureName: 'Garden / Patio' },
    { featureId: '6482', featureName: 'Sea View' },
    { featureId: '6284', featureName: 'Ground Floor Facilities' },
    { featureId: '6590', featureName: 'Rural Location' },
    { featureId: '6743', featureName: 'Woodburning Stove' },
    { featureId: '6536', featureName: 'Open Fire' },
    { featureId: '7070', featureName: 'Baby and Toddler Friendly' },
];
//# sourceMappingURL=uspList.js.map